import { metaDataInterceptorFactory, prefetchQueryInterceptorFactory, staticPageInterceptorFactory } from ".";

import { LiveComponentSourceProps, LiveInterceptorFactory, LiveSourceType } from "../live-component";
import { xpsLoggerProviderInterceptorFactory } from "./xpsLoggerProviderInterceptor";

/**
 * The interceptors that run before and after the Component-defined interceptors.
 * @param lcType - Is this a page component?
 * @returns
 */
export const getInterceptorFactories = (lcType: LiveSourceType) => {
  const whenPage = <T extends LiveComponentSourceProps>(i: LiveInterceptorFactory<T>) => (lcType === "page" ? i : []);
  return {
    // These interceptors execute before the component-defined interceptors
    earlyInterceptors: [
      xpsLoggerProviderInterceptorFactory,
      whenPage(staticPageInterceptorFactory),
      prefetchQueryInterceptorFactory,
    ].flat(),
    // These interceptors execute after the component-defined interceptors
    lateInterceptors: [
      // MetaData is a late interceptor so it doesn't run if a component-defined interceptor refuses to render.
      whenPage(metaDataInterceptorFactory),
    ].flat(),
  };
};
